import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26317fbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BigPlaceholder P-Rel Shadow3" }
const _hoisted_2 = {
  class: "BG1 W-100 H-100 D-Flex FlexColumn",
  style: {"overflow":"hidden"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"0%"},
  class: "MainImage"
}, null, -1))
const _hoisted_4 = {
  style: {"height":"70%"},
  class: ""
}
const _hoisted_5 = { class: "W-100 H-100 P-Rel" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_7 = {
  style: {"height":"10%"},
  class: "MainImage D-Flex FlexColumn"
}
const _hoisted_8 = { class: "M-Auto F2em F-Bold" }
const _hoisted_9 = { class: "M-Auto" }
const _hoisted_10 = {
  style: {"height":"10%"},
  class: "MainImage D-Flex"
}
const _hoisted_11 = { class: "CookiesButton BGMain F1_5em Shadow2 M-Auto" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"10%"},
  class: "MainImage scroller HorizontalFaddedEdge"
}, " ascasc ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"10%"},
  class: "MainImage scroller HorizontalFaddedEdge"
}, " asc ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesButton = _resolveComponent("CookiesButton")!
  const _component_AdminUIPanel = _resolveComponent("AdminUIPanel")!
  const _component_WhatsappBuuble = _resolveComponent("WhatsappBuuble")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "P-Abs Inset0 BannerLogo Shadow3 M-Auto",
              style: _normalizeStyle(['border-radius: ' + _ctx.DesignLayout.Radius,
            'width: ' + _ctx.DesignLayout.LogoSize,
            'height: ' + _ctx.DesignLayout.LogoSize,
            `background-image: url('${ _ctx.BakedLogo }')`])
            }, null, 4)
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.MEMRead('CatalogsMainView_Title')), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.MEMRead('CatalogsMainView_Description')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_CookiesButton, {
            class: "BGMain F1_5em Shadow2 M-Auto",
            Settings: ({ Icon: 'Add'} as CookiesButtonComponent)
          }, {
            default: _withCtx(() => [
              _createTextVNode(" slot ")
            ]),
            _: 1
          }, 8, ["Settings"]),
          _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.Translate('View Catalog')), 1)
        ]),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15
      ])
    ]),
    (_ctx.Access('Catalogue_Edit'))
      ? (_openBlock(), _createBlock(_component_AdminUIPanel, {
          key: 0,
          CookiesSettings: _ctx.AdminPanelSettings,
          Saving: false
        }, null, 8, ["CookiesSettings"]))
      : _createCommentVNode("", true),
    _createVNode(_component_WhatsappBuuble)
  ], 64))
}